import {
    SUCCESS_GET_ALL_PRINTER_PROFILES,
    FAILED_GET_ALL_PRINTER_PROFILES,
    SUCCESS_GET_PRINTER_PROFILE,
    FAILED_GET_PRINTER_PROFILE,
    SUCCESS_CREATE_PRINTER_PROFILE,
    FAILED_CREATE_PRINTER_PROFILE,
    SUCCESS_UPDATE_PRINTER_PROFILE,
    FAILED_UPDATE_PRINTER_PROFILE,
    SUCCESS_DELETE_PRINTER_PROFILE,
    FAILED_DELETE_PRINTER_PROFILE,
} from '../constants/printerProfileConstants';

const defaultState = {
    allPrinterProfiles: [],
    printerProfile: null,
    errorMessage: null,
};

export const PrinterProfileReducer = (state = defaultState, action) => {
    const { type, allPrinterProfiles, printerProfile, errorMessage, deletedId } = action;

    switch (type) {
        case SUCCESS_GET_ALL_PRINTER_PROFILES:
            return {
                ...state,
                allPrinterProfiles: allPrinterProfiles || [],
                errorMessage: null,
            };
        case SUCCESS_GET_PRINTER_PROFILE:
        case SUCCESS_CREATE_PRINTER_PROFILE:
        case SUCCESS_UPDATE_PRINTER_PROFILE:
            return {
                ...state,
                printerProfile: printerProfile || null,
                errorMessage: null,
            };
        case SUCCESS_DELETE_PRINTER_PROFILE:
            return {
                ...state,
                allPrinterProfiles: (state.allPrinterProfiles || []).filter((p) => p.id !== deletedId),
                printerProfile: null,
                errorMessage: null,
            };
        case FAILED_GET_ALL_PRINTER_PROFILES:
        case FAILED_GET_PRINTER_PROFILE:
        case FAILED_CREATE_PRINTER_PROFILE:
        case FAILED_UPDATE_PRINTER_PROFILE:
        case FAILED_DELETE_PRINTER_PROFILE:
            return {
                ...state,
                errorMessage: errorMessage || null,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/state/reducers/printerProfileReducer.js